import { PlanFeaturesProps } from '../../types/components/pricing/PlanFeatures';

import PlanFeatureItem from './PlanFeatureItem';

const PlanFeatures: React.FC<PlanFeaturesProps> = ({
  planType,
  selectedPlanVariant,
  interval,
  features,
  licenseId,
}) => {
  if (!features?.length || !interval) return <></>;

  const getTitle = (): string => {
    return planType === 'enterprise' ?
      'Everything in Startup, plus:' :
      'Features:'
  }

  return (
    <div cy-test-id="plan-features" className="flex flex-col gap-4">
      <span className="text-[16px] leading-[24px]" cy-test-id="title">{getTitle()}</span>
      <ul className="flex flex-col gap-2 text-[14px] md:text-[16px] font-extralight md:leading-[24px]">
        {features.map((feature, index) =>
          <PlanFeatureItem
            feature={feature}
            selectedPlanVariant={selectedPlanVariant}
            interval={interval}
            licenseId={licenseId}
            key={index}
          />
        )}
      </ul>
    </div>
  )
};

export default PlanFeatures;
